import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { Message, ConfirmationService, ConfirmEventType, MenuItem, MessageService } from 'primeng/api';

@Component({
  selector: 'app-ms-vendor',
  templateUrl: './ms-vendor.component.html',
  styleUrls: ['./ms-vendor.component.scss','../../../../mystery-shopper/mystery-shopper.component.scss' ],
  providers: [ConfirmationService,MessageService]
})
export class MsVendorComponent {

  @ViewChild('scrollTarget') scrollTarget!: ElementRef;

  header = this.translate('Vendors');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Vendors'), link: '/ms/vendor' },
  ];
  queryParams: any = {};
  stats: stat[] = [];

  createVendorDisabled: boolean = true;
  companyName: string = '';
  location: string = '';
  classification: string = 'internal';
  pmName: string = '';
  pmEmail: string = '';
  pmMobile: string = '';
  altPmName: string = '';
  altPmEmail: string = '';
  altPmMobile: string = '';
  selectedGender: string = '';
  selectedLocation: string = '';
  city: Array<Location | any> = [];
  ous: Array<OrganizationUnit> = [];
  filtredOus: Array<OrganizationUnit> = [];
  selectedOus: Array<OrganizationUnit> | any = [];
  selectedOusIds: Array<String> | any = [];
  selectionName : string = 'الجهة';
  ouBackup : any;
  allowedTags = ['Ministries/Entities','Organisational Units','Organisational Structure','Branches'];
  gender = [{ label: 'ذكر' }, { label: 'أنثى' }];
  messages: Message[] = [];
  vendors: any[] = [];
  isEdit: boolean = false;
  showExtra: boolean = true;
  editVendorId: string = "";
  editUserId1: string = "";
  editUserId2: string = "";
  skelition = false;
  
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
      this.clearForm();
      Promise.all([this.getOUs(), this.getCity(), this.fetchVendors()]);
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  getName(name: any) {
    return Object.values(name).join(' ');
  }

  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  updateSelectedGender(event: any) {
    this.selectedGender = event.value.label;
  }

  private async fetchVendors(): Promise<void> {
    let res = await this.dataService.getData('ms-vendor-company');
    if (res.error) {
      return;
    }
    this.vendors = res.data;
  }

  async getOUs() {
    try {
      let res = await this.dataService.getData('ou');
      if (!res.error) {
        this.ous = res.data.filter((item:any) => this.allowedTags.includes(item?.type?.tag) && item.active == true)
        this.ouBackup = cloneDeep(this.ous)
        this.filtredOus = this.ous.filter((ou:any) => ou.parent == null);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location._id,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  isFormValid(): boolean {
    if (this.isEdit)
    {
      return (
        this.companyName !== '' &&
        this.location !== '' &&
        this.pmName !== '' &&
        this.pmEmail !== '' &&
        this.pmMobile !== ''
      );
    }
    else{
      return (
        this.companyName !== '' &&
        this.location !== '' &&
        this.pmName !== '' &&
        this.pmEmail !== '' &&
        this.pmMobile !== '' &&
        this.altPmName !== '' &&
        this.altPmEmail !== '' &&
        this.altPmMobile !== ''
      );
    }
  }

  clearForm() {
    this.companyName = "";
    this.location = '';
    this.pmName = '';
    this.pmEmail = '';
    this.pmMobile = '';
    this.altPmName = '';
    this.altPmEmail = '';
    this.altPmMobile = '';
  }

  extractName(fullName: string): { first: string, middle: string, last: string } {
    let firstName = '';
    let middleName = '';
    let lastName = '';

    if (fullName.trim().includes(' ')) {
        const nameParts = fullName.trim().split(' ');
        firstName = nameParts[0];
        if (nameParts.length > 1) {
            lastName = nameParts.pop()!;
        }
        if (nameParts.length > 1) {
            middleName = nameParts.slice(1).join(' ');
        }
    } else {
        firstName = fullName.trim();
    }

    return { first: firstName, middle: middleName, last: lastName };
}

  createData(name: { first: string; middle: string; last: string }, email: string, phone: string, vendorCompanyId:string): any {
    return {
        name: name,
        isVendor: true,
        email: email,
        phone: phone,
        gender: this.selectedGender,
        location: this.location,
        vendorCompanyId: vendorCompanyId,
        active: {
            status: false,
            reason: 'NEW ACCOUNT',
            activationDate: null,
        },
    };
  }

  async createUser(data:any){
    try {
      let res;
      if (this.isEdit) {
        res = await this.dataService.postData(`user`, data, 'PUT', false);
      } else {
        res = await this.dataService.postData(`user/create`, data, 'POST', false);
      }
      if (res.error) {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate(res.msg) 
        });
        this.skelition = false;
        return;
      }
    } catch (error) {
      console.log(error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('error'),
        detail: this.translate("An unexpected error occurred. Please try again.")
      });
    }
  }

  async checkVendor(){
    let errorMessages = [];
    if (!this.isFormValid()) {
      errorMessages.push(this.translate("Please Provide all Valid Data"));
    }
    
    if (!this.isEmailValid(this.pmEmail)) {
      errorMessages.push(this.translate("Please Provide Valid Email"));
    }

    if (!this.isPhoneValid(this.pmMobile)) {
      errorMessages.push(this.translate("Please Provide Valid Phone"));
    }

    if (this.selectedGender == '') {
      errorMessages.push(this.translate("Please Select Gender"));
    }
    if (this.isEdit == false)
    {
      if (!this.isEmailValid(this.altPmEmail)) {
        errorMessages.push(this.translate("Please Provide Valid AltEmail"));
      }

      if (this.pmEmail && this.altPmEmail && this.pmEmail === this.altPmEmail) {
        errorMessages.push(this.translate("Email & Alternative Email cannot be the same"));
      }

      if (!this.isPhoneValid(this.altPmMobile)) {
        errorMessages.push(this.translate("Please Provide Valid AltPhone"));
      }
    }

    if (errorMessages.length > 0) {
      errorMessages.forEach((message) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: message
        });
      });
      return;
    }

    try {
      this.skelition = true;
      let data:any = {
        companyName: this.companyName,
        email1: this.pmEmail,
        email2: this.altPmEmail
      }
      let res = await this.dataService.postData(`ms-vendor-company/checkVendor`, data, 'POST', false);
      if (res.error) {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate(res.msg) 
        });
        this.skelition = false;
        return;
      }

      if (res.success == false) {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate(res.msg) 
        });
        this.skelition = false;
        return;
      }
      this.createCompany();

    } catch (error) {
      console.log(error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('error'),
        detail: this.translate("An unexpected error occurred. Please try again.")
      });
    }
  }

  async createCompany(){

    let errorMessages = [];
    if (!this.isFormValid()) {
      errorMessages.push(this.translate("Please Provide all Valid Data"));
    }
    
    if (!this.isEmailValid(this.pmEmail)) {
      errorMessages.push(this.translate("Please Provide Valid Email"));
    }

    if (!this.isPhoneValid(this.pmMobile)) {
      errorMessages.push(this.translate("Please Provide Valid Phone"));
    }

    if (this.selectedGender == '') {
      errorMessages.push(this.translate("Please Select Gender"));
    }
    if (this.isEdit == false)
    {
      if (!this.isEmailValid(this.altPmEmail)) {
        errorMessages.push(this.translate("Please Provide Valid AltEmail"));
      }

      if (this.pmEmail && this.altPmEmail && this.pmEmail === this.altPmEmail) {
        errorMessages.push(this.translate("Email & Alternative Email cannot be the same"));
      }

      if (!this.isPhoneValid(this.altPmMobile)) {
        errorMessages.push(this.translate("Please Provide Valid AltPhone"));
      }
    }

    if (errorMessages.length > 0) {
      errorMessages.forEach((message) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: message
        });
      });
      return;
    }

    try {
      this.skelition = true;
      let res;
      let data:any = {
        name: this.companyName,
        classification: this.classification
      }
      if (this.isEdit) {
        data._id = this.editVendorId;
        res = await this.dataService.postData(`ms-vendor-company`, data, 'PUT', false);
      } else {
        res = await this.dataService.postData(`ms-vendor-company`, data, 'POST', false);
      }
      if (res.error) {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate(res.msg) 
        });
        this.skelition = false;
        return;
      }
      let compId = null;
      if (this.isEdit == false)
      {
        compId = res.data._id;
      }
      else{
        compId = this.editVendorId;
      }
      const name1 = this.extractName(this.pmName);
      const user1 = this.createData(name1, this.pmEmail, this.pmMobile, compId);
      if (this.isEdit)
      {
        user1._id = this.editUserId1;
      }
      await this.createUser(user1);
      const name2 = this.extractName(this.altPmName);
      const user2 = this.createData(name2, this.altPmEmail, this.altPmMobile, compId);
      if (this.isEdit)
      {
        user2._id = this.editUserId2;
      }
      await this.createUser(user2);
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.isEdit = false;
      this.skelition = false;
      this.ngOnInit();

    } catch (error) {
      console.log(error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('error'),
        detail: this.translate("An unexpected error occurred. Please try again.")
      });
    }
  }

  loadVendor(vendor: any) {
    this.isEdit = true;
    this.showExtra = true;
    this.editVendorId = vendor._id;
    this.editUserId1 = vendor.vendors[0]._id;
    this.editUserId2 = vendor.vendors[1]._id;
    this.companyName = vendor.name;
    this.location = vendor.vendors[0].location;
    this.selectedLocation = '';
    this.pmName = this.getName(vendor.vendors[0].name);
    this.pmEmail = vendor.vendors[0].email;
    this.pmMobile = vendor.vendors[0].phone;
    this.selectedGender = vendor.vendors[0].gender == 'ذكر' ? this.gender[0].label : this.gender[1].label;
    this.altPmName = this.getName(vendor.vendors[1].name);
    this.altPmEmail = vendor.vendors[1].email;
    this.altPmMobile = vendor.vendors[1].phone;

    //scroll into view
    const element = this.scrollTarget?.nativeElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.classification = vendor.classification;
  }

  deleteVendor(vendorId: string, $event: any){
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let res = await this.dataService.deleteData(`ms-vendor-company/`+ vendorId);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });

  }

  cancelEdit() {
    this.clearForm();
    this.isEdit = false;
    this.showExtra = true;
  }

  isEmailValid(email: string): boolean {
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isPhoneValid(phone: string): boolean {
    const phoneRegex: RegExp = /^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/;
    return phoneRegex.test(phone);
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

}
